<template>
  <div id="app">
    <!-- Header -->
    <header class="bg-[#e30713] text-white py-3">
      <div class="mx-5 flex flex-wrap justify-between items-center">
        <h1 class="flex flex-col sm:flex-row items-center gap-2">
          <img class="h-20" src="./assets/img/logo.18b0a5e5.png" alt="LOGO PHIPHITOYS">
          <img class="h-14" src="./assets/img/cmmestrellas.ba1f9893.png" alt="PHRASE PHIPHITOYS">
        </h1>
        
        <!-- Burger Menu Button -->
        <button @click="toggleMenu" class="lg:hidden focus:outline-none ml-auto">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16m-7 6h7"></path>
          </svg>
        </button>

        <!-- Navigation Links -->
        <nav class="hidden lg:block">
          <ul class="flex items-center gap-4 m-0">
            <li><a href="#about" class="text-white no-underline text-sm hover:font-bold">ABOUT US</a></li>
            <li><a href="#values" class="text-white no-underline text-sm hover:font-bold">VALUES</a></li>
            <li><a href="#licences" class="text-white no-underline text-sm hover:font-bold">LICENCES</a></li>
            <li><a href="#clients" class="text-white no-underline text-sm hover:font-bold">CLIENTS</a></li>
            <li><a href="#categories" class="text-white no-underline text-sm hover:font-bold">CATEGORIES</a></li>
            <li><a href="#promos" class="text-white no-underline text-sm hover:font-bold">PROMOTIONAL SOLUTIONS</a></li>
            <li class="bg-white rounded-[15px] px-8 py-2">
              <a href="#contact" class="text-red-600 no-underline text-sm hover:font-bold">CONTACT</a>
            </li>
          </ul>
        </nav>
      </div>

      <!-- Mobile Menu -->
      <div v-if="isMenuOpen" class="lg:hidden bg-[#e30713]">
        <ul class="flex flex-col items-center gap-4 m-0">
          <li><a href="#about" class="text-white no-underline text-sm hover:font-bold">ABOUT US</a></li>
          <li><a href="#values" class="text-white no-underline text-sm hover:font-bold">VALUES</a></li>
          <li><a href="#licences" class="text-white no-underline text-sm hover:font-bold">LICENCES</a></li>
          <li><a href="#clients" class="text-white no-underline text-sm hover:font-bold">CLIENTS</a></li>
          <li><a href="#categories" class="text-white no-underline text-sm hover:font-bold">CATEGORIES</a></li>
          <li><a href="#promos" class="text-white no-underline text-sm hover:font-bold">PROMOTIONAL SOLUTIONS</a></li>
          <li class="bg-white rounded-[15px] px-8 py-2">
            <a href="#contact" class="text-red-600 no-underline text-sm hover:font-bold">CONTACT</a>
          </li>
        </ul>
      </div>
    </header>

    <a href="https://wa.me/+5491141915842" target="_blank" style="z-index: 100;" class="fixed bottom-0 right-0 m-4">
      <img src="./assets/img/wpp.png" alt="WhatsApp" class="w-24 h-auto">
    </a>

    <!-- Hero Section -->
    <section class="bg-gray-100 text-center">
      <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel" data-bs-interval="3000">
        <!-- Carousel Inner (Images) -->
        <div class="carousel-inner">
          <!-- First Image (Active) -->
          <div class="carousel-item active">
            <img src="./assets/img/PPT Group b-02.jpg" class="fotoa" alt="First Slide">
          </div>
          <!-- Second Image -->
          <div class="carousel-item">
            <img src="./assets/img/PPT Group b-03.jpg" class="fotoa" alt="Second Slide">
          </div>
          <!-- Third Image -->
          <div class="carousel-item">
            <img src="./assets/img/PPT Group b-04.jpg" class="fotoa" alt="Third Slide">
          </div>
        </div>
        <!-- Previous Button -->
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <!-- Next Button -->
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
  </section>

    <!-- About Section -->
    <section id="about" class="py-16 bg-white">
      <div class="mx-auto text-center">
        <h2 class="text-3xl font-bold mb-8 text-gray-500">COMPANY</h2>
        <div class="aboutUs py-40 min-h-[calc(100vw*0.2693)] -my-28 md:my-0 flex items-center">
          <div class="relative md:top-10">
            <h4 class="text-gray-700 md:w-1/2 w-full px-14 font-bold" style="font-size: 35px;">About us</h4>
            <p class="text-gray-700 md:w-1/2 w-full px-14">
              <span class="text-red-500 font-bold">Phi Phi Toys</span> is the <span class="text-red-500 font-bold">leader Brand</span> and <span class="text-red-500 font-bold">referent</span> when it comes to development and commercialization of plush toys. We have the biggest <span class="text-red-500 font-bold">assortment</span> contemplating <span class="text-red-500 font-bold">exclusive designs, sizes and colors</span>.
              Our 25 years of experience allows us to work with different <span class="text-red-500 font-bold">licenses</span>, developing and commercializing <span class="text-red-500 font-bold">exclusive</span> products.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Products Section -->
    <section id="product" class="bg-white">
      <div class="mx-auto text-center">
        <div class="ourProduct py-40 -my-28 md:my-0 min-h-[calc(100vw*0.2693)] flex items-center">
          <div>
            <div class="md:flex block">
              <div class="w-1/2 md:block hidden"></div>
              <h4 class="text-gray-700 md:w-1/2 w-full px-14 font-bold" style="font-size: 35px;">Our products</h4>
            </div>
            <div class="md:flex block">
              <div class="w-1/2 md:block hidden"></div>
              <p class="text-gray-700 w-full md:w-1/2 px-14">
                <span class="text-red-500 font-bold">Phi Phi Toys</span> plushies are designed by our creative team and manufactured with <span class="text-red-500 font-bold">high quality</span> materials to achieve products soft to the touch. 
                The careful selection of the colors stimulate the <span class="text-red-500 font-bold">sensory development</span> through play, and our fun designs help <span class="text-red-500 font-bold">sight - touch coordination</span>, motivating the children's <span class="text-red-500 font-bold">imagination</span>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
   
    <section id="promise" class="bg-white">
      <div class="mx-auto text-center">
        <div class="ourPromise py-40 -my-28 md:my-0 min-h-[calc(100vw*0.2693)] flex items-center w-full bg-[position:20%_center] md:bg-center">
          <div>
            <h4 class="text-gray-700 md:w-1/2 w-full px-14 font-bold" style="font-size: 35px;">Our promise</h4>
            <p class="text-gray-700 w-full md:w-1/2 px-14">
              In <span class="text-red-500 font-bold">Phi Phi Toys</span> we sell <span class="text-red-500 font-bold">more</span> than plushies.
              Our products are a synonym of <span class="text-red-500 font-bold">love, illusion, happiness, hugs, companionship and emotion</span>.
              We sell high-impact products, directed to all <span class="text-red-500 font-bold">boys and girls</span> as well as <span class="text-red-500 font-bold">teenagers and adults</span>.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Global Presence Section -->
    <section class="py-16 bg-white">
      <div class="mx-auto text-center">
        <h2 class="text-3xl font-bold mb-8 text-gray-500">FROM CHINA TO THE WORLD</h2>
        <div class="flex flex-wrap">
          <img src="./assets/img/PPT Group b-05.jpg" class=" w-full" alt="">  
          <p class="container m-auto text-gray-700 w-full  md:px-5 pt-5 lg:pt-1">We have over 20 factories where we manufacture in an exclusive way the widest assortment of plushies at the best prices and the highest quality of the market.

Besides our Hong Kong Company, we also have commercial offices in Buenos Aires, Argentina, Montevideo, Uruguay and Los Ángeles, EEUU
          </p>
        </div>
      </div>
    </section>

    <!-- Values Section -->
    <section id="values" class="py-8 bg-white">
      <div class="container mx-auto text-center">
        <h2 class="text-3xl font-bold mb-4 text-gray-500">OUR VALUES</h2>
        <div class="grid sm:grid-cols-2 grid-cols-1 gap-8">
          <div class="bg-white rounded">
            <img class="w-full" src="./assets/img/PPT Group b-07.jpg" alt="">
            <p class="px-6 font-bold text-red-500 pt-4">Integrity</p>
            <p class="px-6">Every action we make is clear, previsible and reliable. We generate bonds with all the value chains.</p>
          </div>
          <div class="bg-white rounded">
            <img class="w-full" src="./assets/img/PPT Group b-08.jpg" alt="">
            <p class="px-6 font-bold text-red-500 pt-4">Quality</p>
            <p class="px-6">We are committed to produce and sell the best quality. We have the highest standards in the market.</p>
          </div>
          <div class="bg-white rounded">
            <img class="w-full" src="./assets/img/PPT Group b-09.jpg" alt="">
            <p class="px-6 font-bold text-red-500 pt-4">Entrepreneurship</p>
            <p class="px-6">We are positive, passionate, and creative. Our resilience allows us to maintain initiative and growth.</p>
          </div>
          <div class="bg-white rounded">
            <img class="w-full" src="./assets/img/PPT Group b-10.jpg" alt="">
            <p class="px-6 font-bold text-red-500 pt-4">Innovation</p>
            <p class="px-6">We embrace change, integrating design, technology and practice to be always on the vanguard.</p>
          </div>
        </div>
      </div>
    </section>

    <img class="w-full" src="./assets/img/PPT Group b-11.jpg" alt="">
    
    <!-- Clients Section -->
    <section id="clients" class="py-8 bg-white">
      <div class="container mx-auto text-center">
        <h2 class="text-3xl font-bold mb-4 text-gray-500">CLIENTS</h2>
        <p class="text-gray-700">Our trajectory, commitment and excellence allows us to generate relationships based on trust with the most important distributors, retailers, supermarket chains and departmental stores, generating long term connections through all the value chain.</p>
      </div>
    </section>

    <img class="mx-auto" src="./assets/img/PPT Group b-12.jpg" alt="">
    
    <section id="licences" class="py-4 bg-white">
      <div class="container mx-auto text-center">
        <h2 class="text-3xl font-bold mb-8 text-gray-500">LICENSES</h2>
      </div>
    </section>

      <img class="w-full lg:block hidden " src="./assets/img/PPT Group b-13.jpg" alt="">
      <img class="w-full lg:hidden block" src="./assets/img/PPT Group b-24.jpg" alt="">
      <p class="container lg:hidden block pt-5">We believe in alliances and in making our relationships grow everyday, and complement our
  offer developing high-quality products for the top licenses all over the world.
  We share with our strategic partners the passion and the carefulness on the development of
  our products.</p>
      <!-- Categories Section -->
      <section id="categories" class="py-8 bg-white">
        <div class="container mx-auto text-center">
          <h2 class="text-3xl font-bold mb-4 text-gray-500">CATEGORIES</h2>
          <p class="text-gray-700">We have the biggest <span class="text-red-500 font-bold">assortment</span> contemplating exclusive <span class="text-red-500 font-bold">designs, sizes and colors</span>.
          </p>
        </div>
      </section>

      <img class="mx-auto lg:hidden block" src="./assets/img/PPT Group b-22.jpg" alt="">
      <img class="mx-auto lg:block hidden" src="./assets/img/PPT Group b-14.jpg" alt="">
      
      <!-- Promotional Solutions Section -->
      <section id="promos" class="pt-4 bg-gray-300">
        <div class="mx-auto text-center p-2">
          <h2 class="text-3xl font-bold">PROMOTIONAL SOLUTIONS</h2>
          <p class="text-gray-700 p-4 md:p-10">We turn <span class="text-red-500 font-bold">ideas into solutions</span>, passion helps selling. <span class="text-red-500 font-bold">Phi Phi Toys</span> offers promotional solutions to make your brand get closer to the consumers. A start-to-end solution.</p>
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-9 mt-5">
            <div class="bg-gray-300 rounded">
              <img class="w-full" src="./assets/img/PPT Group b-15.jpg" alt="">
              <p class="font-bold px-6 text-red-500 pt-3">Design and creativity</p>
              <p class="px-6">We have an expert team fully committed in creating and developing new concepts. Our clients bring their ideas and we make them real, developing a product according to their needs at the best price.</p>
            </div>
            <div class="bg-gray-300 rounded">
              <img class="w-full" src="./assets/img/PPT Group b-16.jpg" alt="">
              <p class="font-bold px-6 text-red-500 pt-3">Production and quality control</p>
              <p class="px-6">For every development we inspect and make sure that all quality standards are followed during the manufacturing.</p>
            </div>
            <div class="bg-gray-300 rounded">
              <img class="w-full" src="./assets/img/PPT Group b-17.jpg" alt="">
              <p class="font-bold px-6 text-red-500 pt-3">Import and distribution</p>
              <p class="px-6">Import and distribution
                We manage all logistic processes to deliver the goods directly in our client's warehouse
              </p>
            </div>
          </div>
      </div>
    </section>

    <!-- Contact Section -->
    <section id="contact" class="py-16 bg-white">
      <div class="mx-auto text-center">
        <h2 class="text-3xl font-bold mb-8 bg-[#e30713] p-5 text-white">CONTACT US</h2>
        <form @submit.prevent="handleSubmit" id="contact-form" class="max-w-lg mx-auto px-5">
          <div class="mb-4">
            <label for="name" class="block text-left">Name</label>
            <input
              type="text"
              id="name"
              required
              v-model="name"
              class="w-full p-2 rounded border border-gray-300 text-black"
            />
          </div>
          <div class="mb-4">
            <label for="email" class="block text-left">Email</label>
            <input
              type="email"
              id="email"
              required
              v-model="email"
              class="w-full p-2 rounded border border-gray-300 text-black"
            />
          </div>
          <div class="mb-4">
            <label for="message" class="block text-left">Message</label>
            <textarea
              id="message"
              class="w-full p-2 rounded border border-gray-300 text-black"
              rows="4"
              v-model="message"
              required
            ></textarea>
          </div>
          <button
            type="submit"
            class="bg-black text-white py-2 px-4 rounded hover:bg-gray-100"
            :disabled="isLoading"
          >
           Send
          </button>
          <br><br>
          <span v-if="isLoading">Loading...</span>
          <br>
          <div v-if="isSuccess" class="bg-green-500 p-5 rounded text-white mt-4 font-bold">
            Your message has been sent successfully!
          </div>
          <div v-if="!isSuccess && isError" class="bg-red-500 p-5 rounded text-white mt-4 font-bold">
            Something is wrong.. try again later!
          </div>
        </form>
      </div>
    </section>

    <!-- Footer -->
    <footer class="bg-[#e30713] text-white py-4">
      <div class="container mx-auto text-center">
        <p>&copy; {{ year }} Phi Phi Toys</p>
      </div>
    </footer>
  </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      year: new Date().getFullYear(),
      isMenuOpen: false, // State to track if the menu is open
      name: '',
      email: '',
      message: '',
      isLoading: false,
      isSuccess: false,
      isError: false
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen; // Toggle the menu state
    },
    handleSubmit() {
      this.isLoading = true;
      this.isError = false;
      this.isSuccess = false;
      const formData = `Nombre: ${this.name}       -          \nEmail: ${this.email}         -       \nMensaje: ${this.message}`;

      fetch('https://phiphitoys.com.ar:8089/api/auth/mail-hk', {
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain',
        },
        body: formData,
      })
        .then(() => {
          this.name = ''
          this.email = ''
          this.message = ''
          this.isSuccess = true
        })
        .catch((error) => {
          this.isError = true
          console.error(error)
        })
        .finally(() => {
          this.isLoading = false;
        })
    },
  },
}
</script>

<style>
#app {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
p {
  font-size: 20px; /* Adjust the font size as needed */
}
.fotoa {
  width: 100vw;
  height: auto;
  object-fit: cover;
}
.aboutUs {
  width:100%; /* Ensure the section takes full width */
  background-image: url("./assets/img/PPT Group b-19.jpg"); /* Path to your background image */
  background-size: cover; /* Ensures the image covers the entire section */
  background-position: center; /* Centers the image */
  background-repeat: no-repeat;
}
.ourProduct {
  width: 100%; /* Ensure the section takes full width */
  background-image: url("./assets/img/PPT Group b-20.jpg"); /* Path to your background image */
  background-size: cover; /* Ensures the image covers the entire section */
  background-position: center; /* Centers the image */
  background-repeat: no-repeat;
}
.ourPromise {
  width: 100%; /* Ensure the section takes full width */
  background-image: url("./assets/img/PPT Group b-18.jpg"); /* Path to your background image */
  background-size: cover; /* Ensures the image covers the entire section */
  background-position: center; /* Centers the image */
  background-repeat: no-repeat;
}
</style>
